define(['app', './ajax-link'], function (app, ajaxLink) {
  return ajaxLink.extend({
    ui: {
      link: '.js-ajax-link',
      notificationAlerts: '.js-sso-flow-mail--alert',
      notificationSucces: '.js-sso-flow-mail--send'
    },

    options: {
      onSuccessRedirect: false,
      callBack: function () {
        this.$el.removeClass('is-loading box--alert')
        this.$el.addClass('box--success')
        this.ui.notificationAlerts.hide()
        this.ui.notificationSucces.removeClass('is-hidden')
      }
    },

    sendingFeedback: function (e) {
      e.preventDefault()

      this.ui.notificationSucces.addClass('is-hidden')
      this.$el.addClass('is-loading')
    },

    events: {
      'click @ui.link': function (e) {
        this.ajaxLink(e)
        this.sendingFeedback(e)
      }
    }
  })
})
